import axios from 'axios'
import React, { Fragment } from 'react'
import { useEffect } from 'react'
import { useState } from 'react'
import { Row, Button, Col, Modal, Container } from 'react-bootstrap'
import { useDispatch, useSelector } from 'react-redux'


// import BitacoraGestion from '../../Bitacora-gestion-recuperador'


const Acciones = ({handleCloseCIA}) => {
  const [show, setShow] = useState(false)
  const data_modal_cia = useSelector(
    (state) => state.modalCartaCiaTerceroReducer
  )
  const {
    cfg_form16,
    
  } = data_modal_cia
  const data_proceso_extrajudicial = useSelector((state) => state.procesoExtrajudicialReducer)
  const { cfg_form14} = data_proceso_extrajudicial
  const handleClose = () => {
   
    // if(respuestaPostLegaliza && respuestaPostLegaliza.respuestaPostLegaliza["code"]===-1){
    //   setShow(false)
    // }else{
    //   console.log("datos correctos")
    //   history('/area-trabajo-encargado-recupero',{state:{queryState}})
    //   setShow(false)
    // }
      setShow(false)
  }
  const handleShow = () => setShow(true)
 
//   const handleCloseBitacora = () => {
//     setShowBitacora(false)
//   }
//   const handleShowBitacora = () => setShowBitacora(true)
 
 
  return (
    <>
      <style type='text/css'>
        {`
    .btn-carpeta {
      background-color: #F0AD3E;
      color: #FFFFFF;
      width: 140px;
      
    }
    .btn-carpeta:hover{
        background-color:#e1b97f;
        color: #FFFFFF;

    }
    .btn-bitacora {
      background-color: #55B2CE;
      color: #FFFFFF;
      width: 140px;
    }
    .btn-bitacora:hover{
        background-color: #87c9dc;
        color: #FFFFFF;
    } 
    .btn-cambiar {
      background-color:  #286FBF;
      color: #FFFFFF;
      width: 140px;     
      padding:6px 0px 6px 0px;
    }
    .btn-cambiar:hover{
        background-color:  #5b9ad1;
        color: #FFFFFF;
    }
    .btn-actualizar {
      background-color: #C14B49;
      color: #FFFFFF;
      width: 140px;
      padding:6px 0px 6px 0px;

    }
    .btn-actualizar:hover{
        background-color:  #F6897E;
      color: #FFFFFF;
    }
    .btn-recepcionar {
      background-color: #C14B49;
      color: #FFFFFF;
      width: 140px;
      padding:6px 0px 6px 0px;

    }
    .btn-recepcionar:hover{
        background-color: #F6897E;
      color: #FFFFFF;
    }
    .btn-volver {
      
      color: #66CCCC;
      border: 1px solid #C00
     
      width: 140px;

    }
   

    .btn-tamano{
      padding: 1rem 1.5rem;
      font-size: 1.5rem;
    }
    `}
      </style>
      {/* <BitacoraGestion
        handleCloseBitacora={handleCloseBitacora}
        showBitacora={showBitacora}
      /> */}
     
      <Container>
      <Row>
        <Col className='d-flex align-items-end justify-content-end m-2'>
          <Button className='m-2 w-auto' variant='outline-info'  onClick={handleCloseCIA}  >
          {cfg_form16 && cfg_form16.cfg_form16["cartaciatercero-btn-cerrar"]}
          </Button>
         
         
          <Button
            className='m-2'
            variant='actualizar'
            type='onSubmit'
           
          
            name='actualizar'
          >
            {cfg_form16 && cfg_form16.cfg_form16["cartaciatercero-btn-actualizar"]}
          </Button>
          
        </Col>
      </Row>
      </Container>
    </>
  )
}

export default Acciones
